import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  getPyqTopicWiseRequest,
  getPyqSubjectWiseRequest,
  setActiveSubject,
  setSelectedTopic,
} from "../../../../../redux/exam/examSlice";
import "./PyqTopicWise.css";
import images from "../../../../../utilities/images/images";

const PyqTopicWise = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { classId, courseId } = useSelector((state) => state.userActivity);

  const { pyqTopicWiseSubjects, pyqSubjectWiseTopics, activeSubject } =
    useSelector((state) => state.examSlice);

  useEffect(() => {
    dispatch(
      getPyqTopicWiseRequest({ course_id: courseId, class_id: classId })
    );
  }, [dispatch]);

  useEffect(() => {
    if (activeSubject) {
      dispatch(getPyqSubjectWiseRequest({ subject: activeSubject }));
    }
  }, [dispatch, activeSubject]);

  const handleSubjectChange = (subjectName) => {
    dispatch(setActiveSubject(subjectName));
  };

  const handleTopicSelect = (topicId) => {
    const selectedTopic = pyqSubjectWiseTopics.find(
      (topic) => topic.topic_id === topicId
    );
    dispatch(setSelectedTopic(selectedTopic));
    history.push("/practice/topic-wise/pyqset");
  };

  return (
    <div className="topic-wise-container">
      <div className="topic-wise-header">
        <img
          style={{
            marginLeft: "25px",
            width: "24px",
            height: "24px",
            cursor: "pointer",
          }}
          src={images.new_backarrow}
          alt="Back"
          onClick={() => history.push("/practice")}
        />
        <h3 id="practice-wise">Topic Wise Practice</h3>
      </div>

      <div className="subject-tabs">
        {pyqTopicWiseSubjects
          ?.filter((sub) => sub.sub_name !== "Information")
          .map((sub) => (
            <div
              key={sub.sub_id}
              className={`subject-tab ${activeSubject === sub.sub_name ? "active" : ""
                }`}
              onClick={() => handleSubjectChange(sub.sub_name)}
              style={{
                color: activeSubject === sub.sub_name ? sub.text_color : "#888",
              }}
            >
              <img src={sub.icon1} alt={sub.sub_name} />
              <span>{sub.sub_name}</span>
            </div>
          ))}
      </div>

      <div className="topic-grid">
        {pyqSubjectWiseTopics?.map((topic) => (
          <div
            className="topic-card"
            key={topic.topic_id}
            onClick={() => handleTopicSelect(topic.topic_id)}
            style={{ cursor: "pointer" }}
          >
            <div className="topic-left">
              <img src={topic.icon} alt={topic.topic_name} />
              <div>
                <h4>{topic.topic_name}</h4>
                <p>{`0/${topic.total_questions} Sets`}</p>
              </div>
            </div>

            <div className="topic-progress">
              <svg viewBox="0 0 36 36">
                <path
                  className="circle-bg"
                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                />
                <path
                  className="circle"
                  strokeDasharray={` 100`}
                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                />
                <text x="18" y="20.35" className="percentage">
                  {0}%
                </text>
              </svg>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PyqTopicWise;
